import React from "react";
import { useEffect } from "react";

import { Home, ArrowLeft } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";

import howlyfaceSadDarkWebp from "@/assets/howlyface-sad-dark-384.webp";
import howlyfaceSadDark from "@/assets/howlyface-sad-dark.png";
import howlyfaceSadLightWebp from "@/assets/howlyface-sad-light-384.webp";
import howlyfaceSadLight from "@/assets/howlyface-sad-light.png";
import { useTheme } from "@/components/ThemeProvider";
import { Button } from "@/components/ui/button";
import { ButtonWithShortcut } from "@/components/ui/button-with-shortcut";
import { ROUTES } from "@/lib/routes";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { theme } = useTheme();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  // Determine which mascot to show based on theme
  const isDark = theme === "dark" || (theme === "system" && window.matchMedia("(prefers-color-scheme: dark)").matches);
  const mascotImage = isDark ? howlyfaceSadDark : howlyfaceSadLight;
  const mascotImageWebp = isDark ? howlyfaceSadDarkWebp : howlyfaceSadLightWebp;

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <div className="text-center space-y-6 max-w-md">
        <div className="flex justify-center animate-scale-in">
          <picture>
            <source srcSet={mascotImageWebp} type="image/webp" />
            <img 
              src={mascotImage} 
              alt="Confused Howlyface" 
              className="w-64 h-64 object-contain animate-fade-in"
              width="384"
              height="384"
            />
          </picture>
        </div>
        <div className="space-y-2 animate-fade-in">
          <h1 className="text-6xl font-bold text-foreground">404</h1>
          <h2 className="text-2xl font-semibold text-foreground">Page Not Found</h2>
          <p className="text-muted-foreground">
            Oops! Howly couldn't find the page you're looking for.
          </p>
        </div>
        <div className="flex gap-3 justify-center animate-fade-in">
          <ButtonWithShortcut 
            onClick={() => navigate(-1)} 
            variant="outline"
            shortcut="Esc"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Go Back
          </ButtonWithShortcut>
          <Button onClick={() => navigate(ROUTES.HOME)}>
            <Home className="mr-2 h-4 w-4" />
            Home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
